import { useEffect } from 'react'
import { atom, useRecoilState } from 'recoil'

import { API_PARAMS } from '../config/consts'
import { calcDay } from '../utils/date'
import { LocationDateTimeItem } from './useLocationDateTimeForm'

const today = new Date()

export const LocationDateTimeRelayAtom = atom<LocationDateTimeItem>({
  key: 'LocationDateTimeRelayAtom',
  default: {
    radio: 'site',
    siteId: API_PARAMS.SELECT_ALL,
    floorId: API_PARAMS.SELECT_ALL,
    siteGroupId: '',
    range: '1',
    fromDate: calcDay(today, -1),
    // toDate: today,
    toDate: calcDay(today, -1),
  },
})

const useLocationDateTimeRelayForm = () => {
  const [relay, setRelay] = useRecoilState(LocationDateTimeRelayAtom)

  // radio effect
  useEffect(() => {
    if (relay.radio === 'site') {
      setRelay((prev) => ({
        ...prev,
        site: API_PARAMS.SELECT_ALL,
        floor: API_PARAMS.SELECT_ALL,
        siteGroupId: '',
      }))
    } else {
      setRelay((prev) => ({
        ...prev,
        site: '',
        floor: '',
        siteGroupId: API_PARAMS.SELECT_ALL,
      }))
    }
  }, [relay.radio, setRelay])

  // site effect
  useEffect(() => {
    setRelay((prev) => ({ ...prev, floor: API_PARAMS.SELECT_ALL }))
  }, [relay.siteId, setRelay])

  // range effect
  useEffect(() => {
    if (relay.range === '9') {
      setRelay((prev) => ({ ...prev, fromDate: null, toDate: null }))
    } else {
      setRelay((prev) => ({
        ...prev,
        fromDate: calcDay(today, -parseInt(relay.range ?? '0', 10)),
        toDate: calcDay(today, -1),
        // toDate: today,
      }))
    }
  }, [relay.range, setRelay])

  // date effect
  useEffect(() => {
    if (relay.fromDate && relay.toDate) {
      if (relay.fromDate > relay.toDate) {
        setRelay((prev) => ({ ...prev, fromDate: relay.toDate, toDate: relay.fromDate }))
      }
    }
  }, [relay.fromDate, relay.toDate, setRelay])

  return { relay, setRelay }
}

export default useLocationDateTimeRelayForm
